import React, { FC, RefAttributes, forwardRef, Ref, InputHTMLAttributes } from 'react';
import InputMask from 'react-input-mask';

export interface EntryProps extends InputHTMLAttributes<HTMLInputElement> {
  mask?: string | Array<RegExp>;
  maskChar?: string;
}

export const Entry: FC<
  EntryProps & RefAttributes<HTMLInputElement>
> = forwardRef(({ mask, maskChar = '', ...rest }, ref) =>
  mask ? <InputMask {...rest} mask={mask} maskPlaceholder={maskChar} ref={ref} /> : <input ref={ref} {...rest} />
);
Entry.displayName = 'Entry';
export default Entry;
